import { render, staticRenderFns } from "./SingleAmazingProduct.vue?vue&type=template&id=2ed279e6&scoped=true"
import script from "./SingleAmazingProduct.vue?vue&type=script&lang=js"
export * from "./SingleAmazingProduct.vue?vue&type=script&lang=js"
import style0 from "./SingleAmazingProduct.vue?vue&type=style&index=0&id=2ed279e6&prod&scoped=true&lang=css"
import style1 from "./SingleAmazingProduct.vue?vue&type=style&index=1&id=2ed279e6&prod&lang=css"
import style2 from "./SingleAmazingProduct.vue?vue&type=style&index=2&id=2ed279e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed279e6",
  null
  
)

export default component.exports